/* unplugin-vue-components disabled */import { render } from "./AreaInfo.vue?vue&type=template&id=622fbb5a&ts=true"
import script from "./AreaInfo.vue?vue&type=script&lang=ts"
export * from "./AreaInfo.vue?vue&type=script&lang=ts"

import "./AreaInfo.vue?vue&type=style&index=0&id=622fbb5a&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_9SbA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__